/* handpanladen · Link-System (22.10.2026)
   1. Ablaufdatum: Elemente mit data-bis="2026-12-02T22:00:00+01:00" verschwinden danach.
      Hat das Element data-nach="…", wird stattdessen dieser Text gesetzt (z. B. „Gast-Künstlerin“).
      Liquid prüft das Datum beim Rendern schon; das Skript fängt zwischengespeicherte Seiten ab.
   2. Klick-Markierung: Links/Knöpfe mit data-hpl-cta="<section>:<ziel>" melden beim Klick
      Shopify.analytics.publish('hpl_cta_click', {cta, page}) (Custom Pixels) und genau ein dataLayer-Ereignis
      {event: 'hpl_cta_click', cta, page, destination} für den GTM-Tag (ein GA4-Treffer).
      Startseite: Links ohne Markierung (Richtext, Karten-Popups) bekommen <section>:<ziel> automatisch.
      Seiten mit data-hpl-page="<name>" an einem Element (Produktseiten mit aufbau_kompakt, 22.10.2026):
      page ist dieser Name statt des Pfads, Links im main ohne Markierung melden <name>:<ziel>. */
(function () {
  'use strict';

  function ablauf() {
    var jetzt = Date.now();
    var els = document.querySelectorAll('[data-bis]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var bis = Date.parse(el.getAttribute('data-bis'));
      if (isNaN(bis) || jetzt <= bis) continue;
      if (el.hasAttribute('data-nach')) {
        el.textContent = el.getAttribute('data-nach');
        el.removeAttribute('data-bis');
      } else {
        el.hidden = true;
        el.style.display = 'none';
      }
    }
  }

  function seite() {
    var markiert = document.querySelector('[data-hpl-page]');
    if (markiert) return markiert.getAttribute('data-hpl-page');
    var p = location.pathname.replace(/\/+$/, '');
    return (p === '' || p === '/de' || p === '/en') ? 'startseite' : p;
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-hpl-cta]') : null;
    var page = seite();
    var cta;
    if (el) {
      cta = el.getAttribute('data-hpl-cta');
    } else {
      /* Rückfall für Links ohne Markierung (Richtext-Felder, Karten-Popups) auf der Startseite:
         <Section ohne hpl_>:<letzter Teil des Links> */
      var eigen = document.querySelector('[data-hpl-page]');
      el = ((page === 'startseite' || eigen) && e.target && e.target.closest) ? e.target.closest('main a[href]') : null;
      if (!el) return;
      var sec = el.closest('.shopify-section');
      var bereich = eigen ? page : (sec ? sec.id.replace(/^.*__/, '').replace(/^hpl_/, '') : 'seite');
      var href = el.getAttribute('href') || '';
      var ziel = ((eigen && href.charAt(0) === '#') ? href.slice(1) : href.split('#')[0].split('?')[0].replace(/\/+$/, '').split('/').pop()) || 'start';
      cta = bereich + ':' + ziel;
    }
    melden(cta, el.getAttribute('href') || '');
  }, true);

  function melden(cta, ziel) {
    var page = seite();
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('hpl_cta_click', { cta: cta, page: page });
      }
    } catch (err) { /* Tracking darf nie stören */ }
    /* Genau EIN GA4-Treffer je Klick (23.10.2026): nur das dataLayer-Ereignis, auf das der GTM-Tag hört.
       Kein gtag('event', …) mehr – den sieht GTM ebenfalls als Ereignis, sein Tag schickte dann einen
       zweiten Treffer ohne Parameter (gemessen: 2 Treffer je Klick an G-8GT73PVMR8). Zustimmung regelt GTM. */
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'hpl_cta_click', cta: cta, page: page, destination: ziel || '' });
    } catch (err) { /* still */ }
  }
  /* Für Ereignisse ohne Klick auf ein markiertes Element (z. B. Start eines Players per Skript) */
  window.hplCtaMelden = melden;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ablauf);
  } else {
    ablauf();
  }
})();
